import { getEnvironmentId, isDevelopment } from "./environment"
import { Analytics } from "../modules/analytics"

const environmentId = getEnvironmentId()

const analytics = new Analytics({
  app: "companion",
  environment: environmentId,
  isEnabled: true,
  shouldTrack: !isDevelopment() && environmentId === "scaler",
})

export async function setLoggedInUser(data: any) {
  if (!data) return null

  const userData = {
    data: {
      attributes: {
        user_analytics_id: data?.id,
        user_email: data?.email,
      },
    },
  }

  const { user_analytics_id: userAnalyticsId } = userData.data.attributes
  analytics.identify(userAnalyticsId)
  analytics.setUserAttributes(data)
  analytics.setEventUserAttributes(userData.data.attributes)
}

export default analytics
